(function () {
  // eslint-disable-next-line no-return-assign, no-undef
  return environments = [
    { // Development US
      match: '.devenv.us.printix.net',
      authBaseUrl: 'https://auth.devenv.us.printix.net',
      apiBaseUrl: 'https://api.devenv.us.printix.net',
      partnerPortal: 'https://partners.devenv.us.printix.net'
    },
    { // Testing US
      match: '.testenv.us.printix.net',
      authBaseUrl: 'https://auth.testenv.us.printix.net',
      apiBaseUrl: 'https://api.testenv.us.printix.net',
      partnerPortal: 'https://partners.testenv.us.printix.net'
    },
    { // Production US
      match: '.us.printix.net',
      authBaseUrl: 'https://auth.us.printix.net',
      apiBaseUrl: 'https://api.us.printix.net',
      partnerPortal: 'https://partners.us.printix.net'
    },
    { // Development EU
      match: '.devenv.printix.net',
      authBaseUrl: 'https://auth.devenv.printix.net',
      apiBaseUrl: 'https://api.devenv.printix.net',
      partnerPortal: 'https://partners.devenv.printix.net'
    },
    { // Testing EU
      match: '.testenv.printix.net',
      authBaseUrl: 'https://auth.testenv.printix.net',
      apiBaseUrl: 'https://api.testenv.printix.net',
      partnerPortal: 'https://partners.testenv.printix.net'
    },
    { // Production EU
      match: '.printix.net',
      authBaseUrl: 'https://auth.printix.net',
      apiBaseUrl: 'https://api.printix.net',
      partnerPortal: 'https://partners.printix.net'
    },
    { // PIB sandbox
      match: '.PIB_DOMAIN',
      authBaseUrl: 'https://auth.PIB_DOMAIN',
      apiBaseUrl: 'https://api.PIB_DOMAIN',
      partnerPortal: 'https://partners.PIB_DOMAIN'
    }
  ];
})();
